module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-360w.36ace26a.jpg";